import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  transferTeacherSuperAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/teacher/privilege/transfer",
      payload
    ).then((response) => response);
  },
};

export default {
  actions,
};
